<app-modal-header [title]="title" (closeModal)="closeModal()"></app-modal-header>
<app-data-table-hybrid
      [columnHeader]="columns"
      [isPageable]="true"
      [hasActionsColumn]="false"
      [tableData]="tableData"
      [showSearchFields]="false"
      [showFilters]="false"
      [showTableControls]="false"

    >
        <ng-template #actions let-data="data" let-index="index">
            <action-buttons [actionButtons]=""
                            [data]="data"
                            [index]="index"
                            [model]="data">
            </action-buttons>
        </ng-template>
    </app-data-table-hybrid>